<div class="container">
    <object type="image/svg+xml" data="assets/icons/Zaver_Pageloader_Dots.svg">
    </object>
</div>
